import {
  onlyUnique,
  encodeUnicode,
  ONLY_UNIQUE_FUNCTION,
  formatSongNameBigger,
  TO_TRIMMED_STRING_FUNCTION,
  FORMAT_SONG_NAME_BIGGER_FUNCTION,
  IS_NOT_NULL_OR_EMPTY_STRING_FUNCTION,
} from './misc'
import {
  HOST,
  DEBUG_MODE,
  IS_PRODUCTION,
  CHAIN_ETHEREUM_MAINNET,
} from './config'
import { toStringOrNull, toTrimmedString, isNotNullOrEmptyString } from './misc'
import { translate } from './language'

export async function upsertOrDeletePlaylist(
  playlistId: any,
  walletAddress: any,
  name: any,
  description: any,
  created: any,
  updated: any,
  deleted: any,
  users: any,
  web2UserId: any,
  forDailyBusinessHours: any,
  shuffleOnPlay: any,
  autoplayPlaylists: any,
  editingWeb2UserId: any,
  isStation: any,
  published: boolean | null,
) {
  return new Promise<any>(async (resolve) => {
    try {
      if (
        isNotNullOrEmptyString(name) &&
        (isNotNullOrEmptyString(walletAddress) ||
          isNotNullOrEmptyString(web2UserId))
      ) {
        const strBodyPlaylistData: any = JSON.stringify({
          playlistId: toStringOrNull(playlistId),
          address: toTrimmedString(walletAddress),
          chain_id: toTrimmedString(CHAIN_ETHEREUM_MAINNET),
          name: encodeUnicode(name),
          description: description != null ? encodeUnicode(description) : null,
          created: created,
          updated: updated,
          deleted: deleted,
          published: published,
          users: users,
          web2UserId: web2UserId,
          forDailyBusinessHours: forDailyBusinessHours,
          shuffleOnPlay: shuffleOnPlay,
          autoplayPlaylists: autoplayPlaylists,
          editingWeb2UserId: editingWeb2UserId,
          isStation: isStation,
        })
        const urlencoded: URLSearchParams = new URLSearchParams({
          playlistData: JSON.stringify(JSON.parse(strBodyPlaylistData)),
        })
        const opts: any = {
          method: 'POST',
          body: urlencoded,
        }
        await fetch(HOST + '/api/p.stream-sv/pl/pp', opts)
          .then(async (resp: any) => {
            const respon: any = await resp.json()
            resolve(respon?.success ? respon?.playlistId : null)
          })
          .catch((er: any) => {
            if (DEBUG_MODE) console.log(er)
            resolve(null)
          })
      } else resolve(null)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve(null)
    }
  })
}

export function translatePresentPlaylistName(
  name: any,
  selectedLanguage: any,
  isPresetOrStationPlaylist: boolean,
) {
  let ret: string = toTrimmedString(name)
  if (isPresetOrStationPlaylist) {
    try {
      if (ret == 'General Pop')
        ret = translate(name, 'Populare', 'Pop', '팝', selectedLanguage)
      else if (ret == 'Indie Pop')
        ret = translate(
          name,
          'Pop Indie',
          'Pop Indé',
          '인디팝',
          selectedLanguage,
        )
      else if (ret == 'Pop Rock')
        ret = translate(name, 'Rock Pop', 'Pop Rock', '팝락', selectedLanguage)
      else if (ret == 'Pop Soft Rock')
        ret = translate(
          name,
          'Pop Rock Suave',
          'Pop Rock Légère',
          '소프트 록 음악',
          selectedLanguage,
        )
      else if (ret == 'Folk Pop')
        ret = translate(name, 'Pop Folk', 'Pop Folk', '포크', selectedLanguage)
      else if (ret == 'Electronic')
        ret = translate(
          name,
          'Electrónica',
          'Électronique',
          '전자',
          selectedLanguage,
        )
      else if (ret == 'EDM')
        ret = translate(name, 'EDM', 'EDM', '이디엠', selectedLanguage)
      else if (ret == 'Downtempo Pop')
        ret = translate(
          name,
          'Tempos Bajos',
          'Tempo Lent',
          '느린 템포',
          selectedLanguage,
        )
      else if (ret == 'Chamber Pop')
        ret = translate(
          name,
          'Pop Cámara',
          'Pop Chambre',
          '챔버 팝',
          selectedLanguage,
        )
      else if (ret == 'R&B')
        ret = translate(name, 'R&B', 'R&B', 'R&B', selectedLanguage)
      else if (ret == 'Country')
        ret = translate(
          name,
          'Country',
          'Country',
          '컨트리 뮤직',
          selectedLanguage,
        )
      else if (ret == 'Classical')
        ret = translate(
          name,
          'Clásica',
          'Classique',
          '클래식',
          selectedLanguage,
        )
      else if (ret == 'Blues & Jazz')
        ret = translate(
          name,
          'Blues y Jazz',
          'Blues et Jazz',
          '블루스 / 재즈',
          selectedLanguage,
        )
      else if (ret == 'Drums And Bass')
        ret = translate(
          name,
          'Drums And Bass',
          'Drums And Bass',
          '드럼 앤 베이스',
          selectedLanguage,
        )
      else if (ret == "Editor's Picks")
        ret = translate(
          name,
          'Elección del Editor',
          "Choix de l'Éditeur",
          '편집자 추천',
          selectedLanguage,
        )
      else if (ret == 'Bar')
        ret = translate(name, 'Taberna', 'Taverne', '선술집', selectedLanguage)
      else if (ret == 'Café')
        ret = translate(name, 'Cafetería', 'Café', '카페', selectedLanguage)
      else if (ret == 'Spa')
        ret = translate(name, 'Spa', 'Spa', '스파', selectedLanguage)
      else if (ret == 'Party')
        ret = translate(name, 'Disco', 'Disco', '나이트클럽', selectedLanguage)
      else if (ret == 'Shop')
        ret = translate(name, 'Almacenar', 'Magasin', '가게', selectedLanguage)
      else if (ret == 'Chill')
        ret = translate(
          name,
          'Relajarse',
          'Refroidir',
          '기분 전환',
          selectedLanguage,
        )
      else if (ret == 'Pump')
        ret = translate(name, 'Gimnasia', 'Sportif', '체육관', selectedLanguage)
      else if (ret == 'Luxury')
        ret = translate(name, 'Lujo', 'Luxe', '명품 매장', selectedLanguage)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
    }
  }
  return ret
}

export async function getSinglePlaylist(
  playlistId: number,
  allSongs: any,
  requestingWeb2UserId: any,
) {
  return new Promise<any>(async (resolve) => {
    try {
      if (playlistId > 0) {
        const opts: any = {
          method: 'POST',
          body: JSON.stringify({
            playlistId: playlistId,
            requestingWeb2UserId: requestingWeb2UserId,
          }),
        }
        await fetch(HOST + '/api/p.stream-sv/pl/gp', opts)
          .then(async (x: any) => {
            const rez: any = await x.json()
            let ret: any = rez?.playlist ? rez?.playlist : null
            if (ret != null) {
              ret = mergePlaylistEntriesWithSongs([ret], allSongs)
              resolve(ret[0])
            } else resolve(null)
          })
          .catch((y: any) => {
            if (DEBUG_MODE) console.log(y)
            resolve(null)
          })
      } else resolve(null)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve(null)
    }
  })
}

export async function postPlaylistEntries(
  playlistId: any,
  playlistEntries: any,
  web2UserId: any,
) {
  return new Promise<any>(async (resolve) => {
    try {
      if (
        isNotNullOrEmptyString(playlistId) &&
        playlistEntries?.length > -1 &&
        isNotNullOrEmptyString(web2UserId)
      ) {
        let simplifiedPlaylistEntries: any = []
        playlistEntries?.map((pe: any) => {
          if (pe) {
            simplifiedPlaylistEntries.push({
              sortOrder: pe?.sortOrder,
              token_id: toTrimmedString(pe?.token_id),
              contract_address: toTrimmedString(pe?.contract_address),
            })
          }
        })
        let urlencoded: URLSearchParams = new URLSearchParams({
          playlistEntriesData: JSON.stringify({
            playlistId: toTrimmedString(playlistId),
            playlistEntries: simplifiedPlaylistEntries,
            web2UserId: toTrimmedString(web2UserId),
          }),
        })
        const axios: any = (await import('axios')).default
        await axios
          .post('/api/p.stream-sv/pe/ppe', urlencoded)
          .then((data: any) => {
            resolve(data?.data)
          })
          .catch((er: any) => {
            if (DEBUG_MODE) console.log(er)
            resolve({
              success: false,
              exceededMaximum: false,
            })
          })
      } else
        resolve({
          success: false,
          exceededMaximum: false,
        })
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve({
        success: false,
        exceededMaximum: false,
      })
    }
  })
}

export async function postPlaylistEntry(
  playlistId: any,
  contract_address: any,
  token_id: any,
  web2UserId: any,
) {
  return new Promise<any>(async (resolve) => {
    try {
      if (
        isNotNullOrEmptyString(playlistId) &&
        isNotNullOrEmptyString(contract_address) &&
        isNotNullOrEmptyString(token_id) &&
        isNotNullOrEmptyString(web2UserId)
      ) {
        let urlencoded: URLSearchParams = new URLSearchParams({
          playlistEntriesData: JSON.stringify({
            playlistId: toTrimmedString(playlistId),
            token_id: toTrimmedString(token_id),
            contract_address: toTrimmedString(contract_address),
            web2UserId: toTrimmedString(web2UserId),
          }),
        })
        const axios: any = (await import('axios')).default
        await axios
          .post('/api/p.stream-sv/pe/ppes', urlencoded)
          .then((r: any) => {
            resolve(r?.data)
          })
          .catch((er: any) => {
            if (DEBUG_MODE) console.log(er)
            resolve({
              success: false,
              exceededMaximum: false,
            })
          })
      } else
        resolve({
          success: false,
          exceededMaximum: false,
        })
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve({
        success: false,
        exceededMaximum: false,
      })
    }
  })
}

export async function deletePlaylistEntry(
  playlistId: any,
  contract_address: any,
  token_id: any,
  sortOrder: any,
) {
  return new Promise<boolean>(async (resolve) => {
    try {
      if (
        isNotNullOrEmptyString(playlistId) &&
        isNotNullOrEmptyString(contract_address) &&
        isNotNullOrEmptyString(token_id) &&
        isNotNullOrEmptyString(sortOrder)
      ) {
        let urlencoded: URLSearchParams = new URLSearchParams({
          playlistEntriesData: JSON.stringify({
            playlistId: toTrimmedString(playlistId),
            token_id: toTrimmedString(token_id),
            contract_address: toTrimmedString(contract_address),
            sortOrder: toTrimmedString(sortOrder),
          }),
        })
        const axios: any = (await import('axios')).default
        await axios
          .post('/api/p.stream-sv/pe/dppes', urlencoded)
          .then((r: any) => {
            resolve(r?.data?.success)
          })
          .catch((er: any) => {
            if (DEBUG_MODE) console.log(er)
            resolve(false)
          })
      } else resolve(false)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve(false)
    }
  })
}

const IS_PRESET_USER_PLAYLIST_FUNCTION_STRING: string = `
  function isPresetUserplaylist(pl, loggedIn, sessionId) {
    let ret = false
    try {
      ret =
        !pl ||
        !loggedIn ||
        pl?.web2UserId == null ||
        pl?.web2UserId == undefined ||
        pl?.web2UserId?.toString().trim() == '' ||
        sessionId != pl?.web2UserId
    } catch (e) {
      if (${DEBUG_MODE}) console.log(e)
    }
    return ret
  }
`

export const MERGE_PLAYLIST_ENTRIES_WITH_SONGS_FUNCTION_STRING: string[] = [
  TO_TRIMMED_STRING_FUNCTION +
    IS_NOT_NULL_OR_EMPTY_STRING_FUNCTION +
    FORMAT_SONG_NAME_BIGGER_FUNCTION +
    ONLY_UNIQUE_FUNCTION +
    IS_PRESET_USER_PLAYLIST_FUNCTION_STRING +
    `
function mergePlaylistEntriesWithSongs(playlists, allSongs) {
  let ret = []
  let clonedPl = null
  try {
    if (playlists?.length > 0 && allSongs?.length > 0) {
      playlists.map((pl) => {
        clonedPl = JSON.parse(JSON.stringify(pl))
        if (pl?.entries?.length > 0) {
          clonedPl.entries = []
          let uniqueSongs = []
          if (allSongs?.length > 0) {
            uniqueSongs = allSongs?.filter(onlyUnique)
          }
          pl?.entries?.map((en) => {
            let match = uniqueSongs?.filter(
              (s) =>
                s?.contract_address == en?.contract_address &&
                s?.token_id == en?.token_id &&
                isNotNullOrEmptyString(s?.contract_address) &&
                isNotNullOrEmptyString(s?.token_id)
            )
            if (match?.length > 0) {
              let songMatch = match[0]
              clonedPl.entries.push({
                animation_url: songMatch?.animation_url,
                contract_address: en?.contract_address,
                token_id: en?.token_id,
                artist: songMatch?.artist,
                duration: en?.duration,
                formattedDuration: en?.formattedDuration,
                genres: en?.genres,
                frontImage: songMatch?.frontImage,
                playlistId: en?.playlistId,
                favorited: songMatch?.favorited,
                sortOrder: en?.sortOrder,
                name: formatSongNameBigger(
                  toTrimmedString(songMatch?.name)
                ),
                formattedMintDate: songMatch?.formattedMintDate,
                formattedSongNameSmallSpaceEscaped: songMatch?.formattedSongNameSmallSpaceEscaped,
                formattedSongNameBig: songMatch?.formattedSongNameBig,
                formattedSongNameBigger: songMatch?.formattedSongNameBigger,
                formattedArtistNameBig: songMatch?.formattedArtistNameBig,
                formattedArtistNameBigger: songMatch?.formattedArtistNameBigger,
                keyOne: songMatch?.keyOne,
                keyTwo: songMatch?.keyTwo,
                keyThree: songMatch?.keyThree,
              })
            }
          })
        }
        ret?.push(clonedPl)
      })
    }
  } catch (e) {
    if (${DEBUG_MODE}) console.log(e)
  }
  return ret
}
self.addEventListener('message', async (event) => {
  if (event?.data != undefined && 
      event?.data != null && 
      event?.data?.SHOW_SONGS_AND_ADD_PLAYLISTS_ENABLED != null &&
      event?.data?.clonePlaylists?.length > 0 &&
      event?.data?.allSongs?.length > 0) {
      try {  
          const loggedIn = event?.data?.loggedIn
          const sessionId = event?.data?.sessionId
          let acc = { playlists: [] }
          let repl = null
          let dragPlaylists = []
          let goToPlaylistIdx = null
          let clonePlaylists = event?.data?.clonePlaylists
          let allSongs = event?.data?.allSongs
          clonePlaylists.map(async (rp) => {
            if (rp?.playlist_id && isPresetUserplaylist(rp, loggedIn, sessionId) == false) {
              repl = Object.defineProperties(rp, {
                id: {
                  value: toTrimmedString(rp?.playlist_id),
                  writable: true,
                  enumerable: false,
                },
              })
              acc.playlists.push(repl)
            }
          })
          dragPlaylists = acc?.playlists
          let cln = JSON.parse(JSON.stringify(acc?.playlists))
          let plz = event?.data?.SHOW_SONGS_AND_ADD_PLAYLISTS_ENABLED
            ? mergePlaylistEntriesWithSongs(cln, allSongs)
            : []
          dragPlaylists = event?.data?.SHOW_SONGS_AND_ADD_PLAYLISTS_ENABLED ? plz : cln
          if (dragPlaylists?.length > 0) {
            if (isNotNullOrEmptyString(event?.data?.goToPlaylistId)) {
              dragPlaylists?.map((playlist, index) => {
                if (playlist?.playlist_id == event?.data?.goToPlaylistId) {
                  goToPlaylistIdx = index
                }
              })
            }
          }
          self.postMessage({dragPlaylists: dragPlaylists, 
                            goToPlaylistIdx: goToPlaylistIdx, 
                            success: true})
        } catch (e) {
            if (${DEBUG_MODE}) console.log(e)
            self.postMessage({dragPlaylists: null, 
                              goToPlaylistIdx: null,
                              success: false})
        }
      }
  })
`,
]

export function mergePlaylistEntriesWithSongs(playlists: any, allSongs: any) {
  let ret: any = []
  let clonedPl: any = null
  try {
    if (playlists?.length > 0 && allSongs?.length > 0) {
      playlists.map((pl: any) => {
        clonedPl = JSON.parse(JSON.stringify(pl))
        if (pl?.entries?.length > 0) {
          clonedPl.entries = []
          let uniqueSongs: any = []
          if (allSongs && allSongs?.length > 0) {
            uniqueSongs = allSongs?.filter(onlyUnique)
          }
          pl?.entries?.map((en: any) => {
            let match: any = uniqueSongs?.filter(
              (s: any) =>
                s?.contract_address == en?.contract_address &&
                s?.token_id == en?.token_id &&
                isNotNullOrEmptyString(s?.contract_address) &&
                isNotNullOrEmptyString(s?.token_id),
            )
            if (match?.length > 0) {
              let songMatch: any = match[0]
              clonedPl.entries.push({
                animation_url: songMatch?.animation_url,
                contract_address: en?.contract_address,
                token_id: en?.token_id,
                artist: songMatch?.artist,
                duration: en?.duration,
                formattedDuration: en?.formattedDuration,
                genres: en?.genres,
                frontImage: songMatch?.frontImage,
                playlistId: en?.playlistId,
                favorited: songMatch?.favorited,
                sortOrder: en?.sortOrder,
                name: formatSongNameBigger(toTrimmedString(songMatch?.name)),
                formattedMintDate: songMatch?.formattedMintDate,
                formattedSongNameSmallSpaceEscaped:
                  songMatch?.formattedSongNameSmallSpaceEscaped,
                formattedSongNameBig: songMatch?.formattedSongNameBig,
                formattedSongNameBigger: songMatch?.formattedSongNameBigger,
                formattedArtistNameBig: songMatch?.formattedArtistNameBig,
                formattedArtistNameBigger: songMatch?.formattedArtistNameBigger,
                keyOne: songMatch?.keyOne,
                keyTwo: songMatch?.keyTwo,
                keyThree: songMatch?.keyThree,
              })
            }
          })
        }
        ret?.push(clonedPl)
      })
    }
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export const PLAYLIST_TYPE_CUSTOM: number = 0
export const PLAYLIST_TYPE_PRESET: number = 1
export const PLAYLIST_TYPE_STATION: number = 2
export const PLAYLIST_TYPE_UNKNOWN: number = -1

export const MAXIMUM_PLAYLIST_ENTRIES: number = 4500

export const BAR_PLACES_PRESET_PLAYLIST_ID: number = IS_PRODUCTION ? 35 : 118
export const CHILL_PLACES_PRESET_PLAYLIST_ID: number = IS_PRODUCTION ? 36 : 123
export const PUMP_PLACES_PRESET_PLAYLIST_ID: number = IS_PRODUCTION ? 37 : 124
export const PARTY_PLACES_PRESET_PLAYLIST_ID: number = IS_PRODUCTION ? 38 : 121
export const CAFE_PLACES_PRESET_PLAYLIST_ID: number = IS_PRODUCTION ? 39 : 119
export const SHOP_PLACES_PRESET_PLAYLIST_ID: number = IS_PRODUCTION ? 40 : 122
export const LUXURY_PLACES_PRESET_PLAYLIST_ID: number = IS_PRODUCTION ? 41 : 125
export const SPA_PLACES_PRESET_PLAYLIST_ID: number = IS_PRODUCTION ? 42 : 120

export function isPresetSample(playlist_id: any) {
  let ret: boolean = false
  try {
    ret =
      playlist_id == BAR_PLACES_PRESET_PLAYLIST_ID ||
      playlist_id == SPA_PLACES_PRESET_PLAYLIST_ID ||
      playlist_id == CAFE_PLACES_PRESET_PLAYLIST_ID ||
      playlist_id == SHOP_PLACES_PRESET_PLAYLIST_ID ||
      playlist_id == PUMP_PLACES_PRESET_PLAYLIST_ID ||
      playlist_id == PARTY_PLACES_PRESET_PLAYLIST_ID ||
      playlist_id == CHILL_PLACES_PRESET_PLAYLIST_ID ||
      playlist_id == LUXURY_PLACES_PRESET_PLAYLIST_ID
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}

export function formatDurationForJsonLd(ms: any): string {
  let ret: string = ''
  try {
    if (!ms || ms < 0) ret = 'PT0S'
    const totalSeconds = ms / 1000
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = (totalSeconds % 60).toFixed(3)
    const cleanSeconds = parseFloat(seconds).toString()
    ret = `PT${minutes}M${cleanSeconds}S`
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}
